// extracted by mini-css-extract-plugin
module.exports = {"list":"_3_kH1","item":"_236bZ"};